import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  getSideBarfilesActions,
  SetUserREtrieveActions,
  setTheUserProfileActive, ///--active---tabs
  getShiftStatusPersonsListed, //--shift----------------
  getLeaveStatusPersonsListed, ///--leave----status---------------
  setTheShiftExcelSheetIDS,
  setThePerformsAgentRetrieveACtion, //--appraisal----retrieve---list
  SetTheAppraisalListActions,
  setTheUserDetailsExportActions,
  setTheOnboarderdetailsReportActions,
} from "../../../Redux/Slice";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import AppraisalPerform from "./AppraisalPerform";
import ReactToPrint from "react-to-print";
import ReactTable from "../../AppComponent/Table";
import UserCreateForm from "./UserCreateForm";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import AttendanceExpor from "./AttendanceExpor";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import ActiveEmployeeCreate from "../Active/ActiveEmployeeCreate";
import BlackListCeatePoup from "../Blacklist/BlackListCreatePop";
import swal from "sweetalert2";
import AuthoriedPerson from "./AuthoriedPerson";
import _ from "lodash";
import AttedanceExport from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-08.svg";
import ActiveImg from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-25.svg";
import BlockImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-26.svg";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-07.svg";

const UserProfile = () => {
  const componentRef = useRef();

  const state = useSelector((state) => state);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [toggleActive, setTogleActive] = useState(
    state.UserRetrieve.userRetrireve.is_active != undefined
      ? state.UserRetrieve.userRetrireve.is_active
      : false
  );

  const Swal = require("sweetalert2");

  const [toggleBlackList, setTogleBlackList] = useState(false);
  const [EditIdss, setEditIds] = useState(); //for find the performance--edit or create
  const navigate = useNavigate();
  const [Counts, setCount] = useState(1);
  const [ActiveFor, setActiveFor] = useState(1);
  const dispatch = useDispatch();

  const [UserEditPopup, setUserEditPopup] = useState(false);
  const [EditId, setEditID] = useState();
  ///----- fro the Active create --
  const [InActiveCreatePop, setInActiveCreatePoup] = useState(false);
  ///--- for black list . ,
  const [EmployeeIDsblacklist, setEmployeeIDsblack] = useState();
  const [createblack, setcreatepoupblack] = useState(false);

  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();
  console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() +1;
  console.log(yearAndMonth, "yearAndMonth");
  //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);

  const [Data, setdata] = useState({
    month: months,
    year: date.getFullYear(),
  });

  const debouncedLeaveSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: dtpagesizeLeave,
          page: dtpageindexLevae,
          client_id: " ",
          user: state.ClientBranchIDs.userProfileId,
        };
        dispatch(getLeaveStatusPersonsListed(payload));
      }, 500),
    []
  );




  const debouncedShiftSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          // page_size: dtpagesizeecel,
          page_size:20,
          page: 1,
          client_id: "",
          user: state.ClientBranchIDs.userProfileId,
        };
        // console.log(e, "testnew")
        dispatch(getShiftStatusPersonsListed(payload));
      }, 500),
    []
  );



  

  React.useEffect(() => {
    return () => {
      debouncedShiftSearch.cancel();
      debouncedLeaveSearch.cancel();
    };
  }, [debouncedLeaveSearch, debouncedShiftSearch]);

  ////---- end of the filters
  const [monthYearset, setMonthYear] = useState("");

  ////------month and year based filters-------------------------------
  const handleChange = (e) => {
    const inputValue = e.target.value;
    setMonthYear(inputValue);
    setdtPageindexexcel(1);
  
    const months = new Date(inputValue);
    if (isNaN(months.getTime())) {
      console.error("Invalid date selected");
      return;
    }
    // months.getMonth()
    const selectedMonth = String(months.getMonth() + 1).padStart(2, "0"); // Ensures 2-digit format
    const selectedYear = months.getFullYear();

    
    setYearMpnth(`${selectedYear}-${selectedMonth}`);
    setdata({
      ...Data,
      month: selectedMonth,
      year: selectedYear,
    });

  };

  ////---Black ---- here I changed the client userObject for  to get the user Objects
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  const [openperformance, setopenPerformance] = useState(true);
  //---retrieve----calls-------------
//   useEffect(() => {
//     if (state.ClientBranchIDs.userProfileId != undefined 
//     ) {
//       const payload = {
//         EditId: state.ClientBranchIDs.userProfileId,
//       };
//       dispatch(SetUserREtrieveActions(payload));
//     }
//   }, []);
// console.log(state.clientDetailsCall.ActiveForUserProfile ,state.ClientBranchIDs.userProfileId ,"ActiveForUserProfile sdaActiveForUserProfile" );

  //---for---the attendance export
  useEffect(() => {
    if (
      state.ClientBranchIDs.userProfileId != undefined &&
      state.clientDetailsCall.ActiveForUserProfile === 4
    ) {
      const payload = {
        EditId: state.ClientBranchIDs.userProfileId,
      };
      dispatch(SetUserREtrieveActions(payload));
    }
  }, [state.clientDetailsCall.ActiveForUserProfile]);

  function Counting(value) {
    setCount(value);
    return Counting;
  }
  function capital_letter(str) {
   if (str !== undefined && str !== null) {
      str = str.split(" ");
  
      for (var i = 0; i < str.length; i++) {
        if (str[i]) {
          str[i] = str[i][0].toUpperCase() + str[i].substr(1);
        }
      }
  
      return str.join(" ");
    } else {
      return "--";
    }
  }

  ////----Appraisal-----------------
  //-----Get0-----html---------
  // useEffect(() => {

  // }, [state.clientDetailsCall.ActiveForUserProfile == 3]);
  useEffect(() => {
    if (state.clientDetailsCall.ActiveForUserProfile == 3) {
      const payload = {
        month: Data.month,
        year: Data.year,

        user: state.ClientBranchIDs.userProfileId,
      };

      //   dispatch(setThePerformsAgentRetrieveACtion(payload));
      dispatch(SetTheAppraisalListActions(payload));
    }
  }, [state.clientDetailsCall.ActiveForUserProfile, Data]);

  // console.log(
  //   state.AppraisalDatasListesUDS.AppraisalDataListes,
  //   "AppraisalDataListes",
  //   state.AppraisalDatasListesUDS.Total_Count
  // );

  const columnsPerformances = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name != undefined ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Last Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.last_name != undefined ? (
              <span>{row.row.original.user_id.last_name}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Email",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.email != undefined &&
            row.row.original.user_id.email != null ? (
              <span>{row.row.original.user_id.email}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Role",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.user_role != undefined &&
            row.row.original.user_id.user_role.role != undefined ? (
              <span>{row.row.original.user_id.user_role.role}</span>
            ) : (
              <span>{"--"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {row.row.original.created_at != undefined &&
              row.row.original.created_at != null
                ? `${
                    row.row.original.created_at.slice(0, 10) +
                    "  " +
                    formattedTime
                  }`
                : "---"}
            </span>
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        if (
          row.row.original.perform_answer != null &&
          row.row.original.perform_answer.status != undefined &&
          row.row.original.perform_answer.status != null
        ) {
          const originalString =
            row.row.original.perform_answer != undefined &&
            row.row.original.perform_answer != null
              ? row.row.original.perform_answer.status
              : "";
          const capitalizedString = capitalizeFirstLetter(originalString);
          return (
            <>
              {row.row.original.perform_answer != undefined &&
              row.row.original.perform_answer.status != undefined ? (
                <>
                  {row.row.original.perform_answer.status.toLowerCase() ==
                  "pending" ? (
                    <div className="StatusList">
                      <img src={Pendingimg} />
                      <span>{capitalizedString}</span>
                    </div>
                  ) : (
                    <>
                      {row.row.original.perform_answer.status.toLowerCase() ==
                      "decline" ? (
                        <div className="StatusList">
                          <div className="DeclineStatus">
                            <span>x</span>
                          </div>
                          <span>{capitalizedString}</span>
                        </div>
                      ) : (
                        <>
                          {row.row.original.perform_answer.status.toLowerCase() ==
                          "approved" ? (
                            <div className="StatusList">
                              <img src={correctIcons} />
                              <span>{capitalizedString}</span>
                            </div>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span>---</span>
              )}
            </>
          );
        } else if (row.row.original.perform_answer == null) {
          return (
            <>
              <p>{"-----"}</p>
            </>
          );
        }
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  setEditIds(row.row.original.id);
                  setopenPerformance(!openperformance);
                }}
              >
                
                <span className="OuterActionSpan">
                  <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  ////---Leave---Status----
  const [dtpageindexLevae, setdtPageindexLeave] = useState(1);
  const [dtpagesizeLeave, setdtPagesizeLeve] = useState(20);
  const [pageSizeLeave, setPageSizeLeave] = useState(10);
  const [newpagesLeave, setNewpageLeba] = useState(1);
  const [searchLeabe, setsearchLeave] = useState("");
  const [LeaveData, setLeavedatas] = useState([]);
  const [currentPageLeave, setCurrentPageLeave] = useState(1);
  const [search, setsearch] = useState("");
  const [newpages, setNewpage] = useState(1);
  const [currentPageShift, setCurrentPage] = useState(1);
  const [currentPageemp, setCurrentPageemp] = useState(1);
  useEffect(() => {
    if (state.clientDetailsCall.ActiveForUserProfile == 2) {
      const payload = {
        search: "",
        page_size: dtpagesizeLeave,
        page: dtpageindexLevae,
        client_id: " ",
        user: state.ClientBranchIDs.userProfileId,
      };
      dispatch(getLeaveStatusPersonsListed(payload));
    }
  }, [state.clientDetailsCall.ActiveForUserProfile , dtpageindexLevae]);

  const HandleDownloadLeaveStatus = (documents) => {
    window.open(documents);
  };
  ///-----__Leave----------Employees--------------

  const LeaveColumn = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.user_id.first_name}</span>
          </>
        );
      },
    },
    {
      Header: "From",
      accessor: "from_date",
    },
    {
      Header: "To",
      accessor: "to_date",
    },
    {
      Header: "Note",
      accessor: "notes",
    },
    ///------Leave---document-----uploads
    {
      Header: "Reason",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="LeaveStatusBtn">
              {row.row.original.leave_type != null &&
              row.row.original.leave_type.leave_type != undefined ? (
                <span>{row.row.original.leave_type.leave_type}</span>
              ) : (
                <span>{"---"}</span>
              )}

              {row.row.original.certificate_id != undefined &&
              row.row.original.certificate_id.media_url != undefined ? (
                <button
                  type="button"
                  class="btn "
                  onClick={(e) => {
                    HandleDownloadLeaveStatus(
                      row.row.original.certificate_id.media_url
                    );
                  }}
                >
                  <img src={downloadoffer} alt="Download Offer Letter" />
                  </button>
              ) : (
                <span>{""}</span>
              )}
            </div>
          </>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
  ];

  // const debouncedPerformancetest= useMemo(
  //   () =>
  //     _.debounce((e) => {
  //       const payload = {
  //         search: e,
  //         page_size: dtpagesizeLeave,
  //         page: dtpageindexLevae,
  //         client_id: " ",
  //         user: state.ClientBranchIDs.userProfileId,
  //       };
  //       dispatch(getLeaveStatusPersonsListed(payload));
  //     }, 500),
  //   []
  // );

  // function toPerfromance (e){

  //   debouncedPerformancetest(e)

  // }
  function tochangeLeave(e) {
    // console.log("ee", e);
    setsearchLeave(e);
    debouncedLeaveSearch(e);
    // if (e.trim() != undefined && e.trim() !== "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesizeLeave,
    //     client_id: " ",
    //     user: state.ClientBranchIDs.userProfileId,
    //   };
    //   // console.log(e, "testnew")
    //   dispatch(getLeaveStatusPersonsListed(payload));
    // }
    // if (e == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesizeLeave,
    //     page: 1,
    //     client_id: " ",
    //     user: state.ClientBranchIDs.userProfileId,
    //   };
    //   dispatch(getLeaveStatusPersonsListed(payload));
    // }
  }

  const handleNextLeave = (next) => {
    setdtPageindexLeave(next + 1);
    
  };

  const handlePreviousLeave = (previous) => {
    //  console.log(previous, "previous");
    if (previous != 0) {
      setdtPageindexLeave(previous);
      
    }
  };


  const GotoEnteredPageLeave =(gotopage)=>{
    setdtPageindexLeave(gotopage)
  }

  const pagesizeLevae = (arg) => {
    setdtPagesizeLeve(arg);
  };
  const pageindexLeave = (arg) => {
    //  console.log(arg, "args");
    setdtPageindexLeave(arg);
  };

  ////----shift----------

  /////-----------------___Excel---Sheet----Uploads---Get--LIST-----------------
  const [dtpageindexExcel, setdtPageindexexcel] = useState(1);
  const [dtpagesizeecel, setdtPagesizeexcel] = useState(10);
  const [pageSizeexcel, setPageSizexcel] = useState(20);
  const [currentPageEXcel, setCurrentPageExcel] = useState(1);
  const [newpagesexcel, setNewpageexcel] = useState(1);
  const [searchexcel, setsearchexcel] = useState("");
  ///----Shift-------Upload----get------------------
  useEffect(() => {
    if (state.clientDetailsCall.ActiveForUserProfile == 1) {
      const payload = {
        search: "",
        // page_size: 10,
        page_size:20,

        page: currentPageEXcel,
        client_id: "",
        user: state.ClientBranchIDs.userProfileId,
      };
      dispatch(getShiftStatusPersonsListed(payload));
    }
    // console.log(state.ShfitData.Shiftdatas, "dauysfda Total_Count");
  }, [state.clientDetailsCall.ActiveForUserProfile , currentPageEXcel]);
  const pagesizeexcel = (arg) => {
    setdtPagesizeexcel(arg);
  };
  const pageindexexcel = (arg) => {
    setdtPageindexexcel(arg);
  };


  // -----Search------------------------
  function tochangeshiftExcel(e) {
    setsearchexcel(e);
    debouncedShiftSearch(e);
    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesizeecel,
    //     page: 1,
    //     client_id: "",
    //     user: state.ClientBranchIDs.userProfileId,
    //   };
    //   // console.log(e, "testnew")
    //   dispatch(getShiftStatusPersonsListed(payload));
    // }
    // if (e == "" || searchexcel == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesizeecel,
    //     page: 1,
    //     client_id: "",
    //     user: state.ClientBranchIDs.userProfileId,
    //   };
    //   dispatch(getShiftStatusPersonsListed(payload));
    // }
  }

  const columnShift = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.month ? (
              <spn>{row.row.original.month}</spn>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Year",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.year ? (
              <spn>{row.row.original.year}</spn>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month Start",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.month_start;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;
        return (
          <>
            {row.row.original.month_start ? (
              <span>{`${
                row.row.original.month_start.slice(0, 10) + "  " + formattedTime
              }`}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month End",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.month_end;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;
        return (
          <>
            {row.row.original.month_end ? (
              <span>{`${
                row.row.original.month_end.slice(0, 10) + "  " + formattedTime
              }`}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Leave Counts",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.leave_count ? (
              <span>{row.row.original.leave_count}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
  ];

  const UserDetailsExports = (e, statement, values) => {
    console.log(values, "values");
    const IDS = values == "single" ? e : "";
    Swal.fire({
      title: `Are you sure, do you want to export the user Details records ?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes, Export it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payloads = {
          export_type: values,
          role_id: "",
          user_id: IDS,
        };
        console.log(payloads, "payloadskehqiwu2873409");
        dispatch(setTheUserDetailsExportActions(payloads));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  ///----------__View---------------List-------------
  const handleCalenders = (e) => {
    dispatch(setTheShiftExcelSheetIDS(e.user_id.id));

    if (state.ClientBranchIDs.ShiftExcelsheetID == e.user_id.id) {
      navigate("/calender");
    }
  };


  ///----shift---
  const handleNextexcelsheet = (next) => {    
    setCurrentPageExcel(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
  setCurrentPageExcel(gotopage)
}

const handlePreviousExcelSheet = (previous) => {
if (previous != 0) {
  setCurrentPageExcel(previous);

}
};

  return (
    <>
      <div className="Details">
        <div
          className={stateDisplay ? "outterContent" : "inner-Content"}
          style={{ padding: "30px" }}
        >
          <div className="Header-Details ClientBranch row">
            <div
              // className="InnerUsers"
              class="col-sm-7 auto"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <h5 className="UserProfileheaderssad">Profile</h5>

              {/* <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/user"}
                    onClick={(e) => {
                      dispatch(getSideBarfilesActions("User"));
                    }}
                  >
                    User
                  </NavLink>
                </li>

                <li class="breadcrumb-item active">User Profile </li>
              </ul> */}
            </div>
          </div>

          <div
            className="row Filters ButtonPrevious"
            // style={{
            //   padding: "15px 28px",
            //   margin: "0px",
            //   position: "relative",
            //   zIndex: "30",
            //   marginTop: "-26xp",

            //   marginLeft: "0px",
            //   marginRight: "0px",
            //   top: "-30px",
            // }}
            style={{ marginLeft: "-17px" }}
          >
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/user");
                }}
              >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>
              </button>
            </div>
          </div>

          <div className="row ProfileFile" style={{ marginRight: "0px" }}>
            <div className="col-md-12">
              <div className="row"></div>
              {/* ---------------Tabs------------------------------------ */}
              <div class="profile-header">
                <div
                  class="row  align-items-center"
                  style={{ padding: "1.5rem" }}
                >
                  <div class="col-auto profile-image">
                    <a
                      href={
                        state.UserRetrieve.userRetrireve.user_image != null &&
                        state.UserRetrieve.userRetrireve.user_image != undefined
                          ? state.UserRetrieve.userRetrireve.user_image
                              .media_url
                          : null
                      }
                      target="blank"
                    >
                      <div className="BranchLogo">
                        <img
                          class=""
                          alt="User Image"
                          src={
                            state.UserRetrieve.userRetrireve.user_image !=
                              null &&
                            state.UserRetrieve.userRetrireve.user_image !=
                              undefined
                              ? state.UserRetrieve.userRetrireve.user_image
                                  .media_url
                              : profile2
                          }
                        />
                      </div>
                    </a>
                  </div>

                  <div class="col ml-md-n2 profile-user-info">
                    {state.UserRetrieve.userRetrireve.first_name !=
                    undefined ? (
                      <h4 class="user-name mb-0">
                        {/* {state.BranchRetrieve.BranchesRetrieve.client_name.toUpperCase()} */}
                        {capital_letter(
                          state.UserRetrieve.userRetrireve.first_name
                        )}
                      </h4>
                    ) : null}
                    {state.UserRetrieve.userRetrireve != undefined &&
                    state.UserRetrieve.userRetrireve.user_role != undefined &&
                    state.UserRetrieve.userRetrireve.user_role != null ? (
                      <>
                        <p  className="m-0" style={{ display: "flex", gap: "10px" }}>
                          <span style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                            {state.UserRetrieve.userRetrireve.user_role.role}
                          </span>
                          <span
                            style={{
                              background: "#FAE8D5",
                              padding: "5px",
                              // margin: "2%",
                              height: "100%",
                              color: "red",
                              borderRadius: "5px",
                            }}
                          >
                            {state.UserRetrieve.userRetrireve != undefined &&
                            state.UserRetrieve.userRetrireve.zone_id !=
                              undefined
                              ? `${
                                  state.UserRetrieve.userRetrireve.zone_id
                                    .length > 0
                                    ? state.UserRetrieve.userRetrireve.zone_id
                                        .length
                                    : 0
                                } Zones`
                              : null}
                          </span>

                          <span
                            style={{
                              background: "#FAE8D5",
                              padding: "5px",
                              // margin: "2%",
                              height: "100%",

                              color: "red",
                              borderRadius: "5px",
                            }}
                          >
                            {state.UserRetrieve.userRetrireve != undefined &&
                            state.UserRetrieve.userRetrireve.branch_count !=
                              undefined
                              ? `${
                                  state.UserRetrieve.userRetrireve.branch_count
                                    .length > 0
                                    ? state.UserRetrieve.userRetrireve
                                        .branch_count.length
                                    : 0
                                } Branch`
                              : null}
                          </span>
                          {/* <button  
                          className="ButtonCSS"
                          style={{
                            background: "#FAE8D5",
                            padding: "5px",
                            // margin: "2%",
                            height:"100%",

                            color: "red",
                            borderRadius: "5px",
                          }}
                          onClick={(e) => {
                            const id =state.ClientBranchIDs.userProfileId
                           e.stopPropagation()
         
                           UserDetailsExports(id, true, "single");
                         }}


                          > */}

                          <span
                            style={{
                              background: "#FAE8D5",
                              padding: "5px",
                              // margin: "2%",
                              height: "100%",

                              color: "red",
                              borderRadius: "5px",
                              display:"flex",
                              cursor:"pointer"
                            }}
                            onClick={(e) => {
                              const id = state.ClientBranchIDs.userProfileId;
                              e.stopPropagation();

                              UserDetailsExports(id, true, "single");
                            }}
                          >
                            {/* {" "}
                            <i
                              class="fa-solid fa-file-export"
                              style={{
                                fontSize: "15px",
                                // paddingRight: "3px",
                                // paddingBottom: "3px",
                                padding: "5px",

                                height: "100%",
                              }}
                            ></i> */}
                                        <span  className="AttendanceExportImage">
                    <img src={AttedanceExport}/>
                  </span>
                            Export
                          </span>

                          {/* </button> */}
                        </p>

                        <div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "20px",
                            }}
                          >
                            {!toggleActive ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "3x",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  // setTogleActive(true);
                                  setInActiveCreatePoup(true);
                                  setActiveFor(1);
                                }}
                              >
                                <span  className="InACtive">
                                  <img src={ActiveImg}/>
                                </span>
                                <span style={{ fontWeight: "800" }}>
                                  Inactive
                                </span>
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  // setTogleActive(false);
                                  setInActiveCreatePoup(true);
                                  setActiveFor(2);
                                }}
                              >
                                {/* <i
                                  class="fa-solid fa-toggle-on"
                                  style={{ fontSize: "30px", color: "#F48038" }}
                                ></i> */}
                                <span  className="ActiveImge">
                                  <img src={ActiveImg}/>
                                </span>

                                <span style={{ fontWeight: "800" }}>
                                  Active
                                </span>
                              </div>
                            )}

                            {/* /{!toggleBlackList ? ( */}
                            <button
                              style={{
                                display: "flex",
                                gap: "3px",
                                alignItems: "center",
                                background: "none",
                              }}
                              onClick={(e) => {
                                setTogleBlackList(true);
                                setActiveFor(1);
                                setcreatepoupblack(true);
                              }}
                            >
  <span  className="ActiveImge">
                                  <img src={BlockImage}/>
                                </span>

                              <span style={{ fontWeight: "800" }}>Blocked</span>
                            </button>
                            {/* ) 
                            
                            // : (
                            //   <div */}
                            {/* //     style={{
                            //       display: "flex",
                            //       gap: "6px",
                            //       alignItems: "center",
                            //       cursor: "pointer",
                            //     }}
                            //     onClick={(e) => {
                            //       setTogleBlackList(false);
                            //       setActiveFor(2);
                            //       setcreatepoupblack(true);
                            //     }}
                            //   >
                            //     <i
                            //       class="fa-regular fa-circle"
                            //       style={{ fontSize: "20px", color: "green" }}
                            //     ></i> 
                            //     <span style={{ fontWeight: "800" }}>
                            //       UnBlocked
                            //     </span>
                            //   </div>
                            // )} */}
                          </div>
                        </div>
                      </>
                    ) : null}

                    {/* <p>
                      {state.UserRetrieve.userRetrireve != undefined &&
                      state.UserRetrieve.userRetrireve.branch_count != undefined
                        ? `${I
                            state.UserRetrieve.userRetrireve.branch_count.length > 0
                              ? state.UserRetrieve.userRetrireve.branch_count.length
                              : 0
                          } Branch`
                        : null}
                    </p> */}
                  </div>

                  <div
                    class="col-auto profile-btn"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  ></div>

                  <div class="col-auto profile-btn">
                    <button
                      class="btn  editview"
                      onClick={(e) => {
                        // dispatch(Branch_EDIT_CLIENT_DETAILS(2)); ///--For----close the--client-----details--

                        // setEditPopupBranch(true);

                        setUserEditPopup(true);
                        setEditID(state.ClientBranchIDs.userProfileId);
                      }}
                    >
                      Edit
                    </button>
                  </div>
                </div>

                <div className="profile-menu TabsStartHead">
                  <div className="innerTabs">
                    <ul class="nav nav-tabs" id="ex1" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          // class=" active"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveForUserProfile == 1
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-1"
                          data-bs-toggle="tab"
                          href="#shiftExcel"
                          role="tab"
                          aria-controls="ex3-tabs-1"
                          aria-selected="true"
                          onClick={(e) => {
                            Counting(1);
                            dispatch(setTheUserProfileActive(1));
                          }}
                        >
                          Shift
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          /// class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveForUserProfile == 2
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#leave"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(2);
                            dispatch(setTheUserProfileActive(2));
                          }}
                          //style={{ display: "none" }}
                        >
                          Leave Status
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //  class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveForUserProfile == 3
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#perform"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(2);
                            dispatch(setTheUserProfileActive(3));
                          }}
                        >
                          Performance
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //  class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveForUserProfile == 4
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#attendance"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(2);
                            dispatch(setTheUserProfileActive(4));
                          }}
                        >
                          Attendance Export
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //  class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveForUserProfile == 5
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-persoan"
                          data-bs-toggle="tab"
                          href="#Authorizated"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(2);
                            dispatch(setTheUserProfileActive(5));
                          }}
                        >
                          Authorized Person
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* ----------------------Tab---Content--------------------------------- */}
              <div className="card BeforeTabs ">
                <div className="card-body innerBody">
                  <div className="TabsStart">
                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <div className="card-body DetailsPart">
                            <div class="tab-content" id="ex2-content">
                              <div
                                //  class="tab-pane fade"
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall
                                    .ActiveForUserProfile == 3
                                    ? "active "
                                    : ""
                                }`}
                                id="perform"
                                role="tabpanel"
                                aria-labelledby="ex3-tab-2"
                              >
                                {/* <div
                                  className="UserButtons"
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "20px",
                                    marginTop: "20px",
                                    marginBottom: "20px",
                                    alignItems: "center",
                                    marginRight: "20px",
                                  }}
                                >
                                  <ReactToPrint
                                    trigger={() => (
                                      <button
                                        class="btn  SaveBtn"
                                        style={{
                                          background: "#ef4d39",
                                          color: "white",
                                        }}
                                      >
                                        Print
                                      </button>
                                    )}
                                    content={() => componentRef.current}
                                  />
                                  <div></div>
                                </div> */}

                                <div
                                  className="UserButtons"
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "20px",
                                    marginTop: "20px",
                                    marginBottom: "20px",
                                    alignItems: "center",
                                    marginRight: "20px",
                                  }}
                                >
                                  <button
                                    class="btn  SaveBtn"
                                    style={{
                                      background: "#ef4d39",
                                      color: "white",
                                    }}
                                    onClick={(e) => {
                                      setopenPerformance(!openperformance);
                                      setEditIds("");
                                    }}
                                  >
                                    {openperformance ? "Create" : "X"}
                                  </button>
                                  <div></div>
                                </div>
                                {!openperformance ? (
                                  <>
                                    <div className="row">
                                      <div className="col-6"></div>
                                      <div
                                        className="col-6"
                                        style={{
                                          display: "flex",
                                          justifyContent: "end",
                                          alignItems: "flex-end",
                                          position: "relative",
                                          paddingRight: "56px",
                                        }}
                                      >
                                        <ReactToPrint
                                          trigger={() => (
                                            <button
                                              class="btn  SaveBtn"
                                              style={{
                                                background: "#ef4d39",
                                                color: "white",
                                              }}
                                            >
                                              Print
                                            </button>
                                          )}
                                          content={() => componentRef.current}
                                        />
                                      </div>
                                    </div>
                                  </>
                                ) : null}

                                {/* <AppraisalPerform ref={componentRef} /> */}
                                {openperformance &&
                                state.AppraisalDatasListesUDS
                                  .AppraisalDataListes != null &&
                                state.AppraisalDatasListesUDS
                                  .AppraisalDataListes != undefined ? (
                                  <div style={{ padding: "0px" }}>
                                    <ReactTable
                                      data={
                                        state.AppraisalDatasListesUDS
                                          .AppraisalDataListes
                                      }
                                      columns={columnsPerformances}
                                      totalItems={
                                        state.AppraisalDatasListesUDS
                                          .Total_Count
                                      }
                                      currentPage={1}
                                      // onChange={toPerfromance}
                                      Search={true}
                                      setCurrentPage={setCurrentPageExcel}
                                      pagesize={pagesizeexcel}
                                      dtpagesize={pageSizeexcel}
                                      dtpageindex={currentPageEXcel}
                                      pageindex={pageindexexcel}
                                      datacount={
                                        state.AppraisalDatasListesUDS
                                          .Total_Count
                                      }
                                      
                                      // placeHold={"ALL"}
                                      nostatusFilter={true}
                                      // //---Month based filter
                                      MonthFilter={true}
                                      yearAndMonth={yearAndMonth}
                                      handleChange={handleChange}

                                      Filter={true}
             NoFilter ={false}
                                    />
                                  </div>
                                ) : (
                                  <>
                                    {!openperformance &&
                                    state.AppraisalDatasListesUDS
                                      .AppraisalDataListes != null &&
                                    state.AppraisalDatasListesUDS
                                      .AppraisalDataListes != undefined ? (
                                      <AppraisalPerform
                                        ref={componentRef}
                                        setshow={setopenPerformance}
                                        setEditIds={EditIdss}
                                        month={Data.month}
                                        year={Data.year}

                                        

                                                                          NoFilter ={true}

                                      />
                                    ) : (
                                      <p style={{ textAlign: "center" }}>
                                        {"NO DATA"}
                                      </p>
                                    )}
                                  </>
                                )}
                              </div>

                              {/* -------------------Shift---Exce;------------Status---------------- */}
                              <div
                                //  class="tab-pane fade  "

                                className={`  tab-pane fade show  ExcelSheetGetList ${
                                  state.clientDetailsCall
                                    .ActiveForUserProfile == 1
                                    ? "active "
                                    : ""
                                }`}
                                id="shiftExcel"
                                // /style={{ display: "none" }}
                                role="tabpanel"
                                aria-labelledby="ex3-tab-2"
                              >
                                <div style={{ padding: "0px" }}>
                                  <ReactTable
                                    data={state.ShfitData.Shiftdatas}
                                    columns={columnShift}
                                    totalItems={state.ShfitData.Total_Count}
                                    currentPage={currentPageEXcel}
                                    onChange={tochangeshiftExcel}
                                    setCurrentPage={setCurrentPageExcel}
                                    pagesize={pagesizeexcel}
                                    onPrevious={handlePreviousExcelSheet}
                                    onNextpage={handleNextexcelsheet}
                                    GotoEnteredPage={GotoEnteredPage}
                                    dtpagesize={pageSizeexcel}
                                    dtpageindex={currentPageEXcel}
                                    pageindex={pageindexexcel}
                                    datacount={state.ShfitData.Total_Count}

                                    Filter={true}
             NoFilter ={true}
                                  />
                                </div>
                              </div>

                              {/* -------------------Leave------------Status---------------- */}
                              <div
                                //   class="tab-pane fade "
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall
                                    .ActiveForUserProfile == 2
                                    ? "active "
                                    : ""
                                }`}
                                id="leave"
                                role="tabpanel"
                                aria-labelledby="ex3-tab-1"
                              >
                                <ReactTable
                                  data={state.LeaveStatusListed.LeaveStatusLis}
                                  columns={LeaveColumn}
                                  totalItems={
                                    state.LeaveStatusListed.Total_Count
                                  }
                                  currentPage={currentPageLeave}
                                  onChange={tochangeLeave}
                                  setCurrentPage={setCurrentPageLeave}
                                  pagesize={pagesizeLevae}
                                  onPrevious={handlePreviousLeave}
                                  onNextpage={handleNextLeave}
                                  GotoEnteredPage={GotoEnteredPageLeave}
                                  dtpagesize={dtpagesizeLeave}
                                  dtpageindex={dtpageindexLevae}
                                  pageindex={pageindexLeave}
                                  datacount={
                                    state.LeaveStatusListed.Total_Count
                                  }
                                  Filter={true}
                                  NoFilter ={true}


                                 
                                />
                              </div>

                              {/* ----------------_-----Attendance----Export----------------------- */}
                              <div
                                id="attendance"
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall
                                    .ActiveForUserProfile == 4
                                    ? "active "
                                    : ""
                                }`}
                                role="tabpanel"
                                aria-labelledby="ex3-tab-1"
                              >
                                <AttendanceExpor />
                              </div>

                              {/* ------------------------Authorized--preson------------ */}

                              <div
                                id="Authorizated"
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall
                                    .ActiveForUserProfile == 5
                                    ? "active "
                                    : ""
                                }`}
                                role="tabpanel"
                                aria-labelledby="ex3-tab-persoan"
                              >
                                <AuthoriedPerson />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {state.ClientBranchIDs.userProfileId != undefined && UserEditPopup ? (
        <UserCreateForm
          show={UserEditPopup}
          EditId={state.ClientBranchIDs.userProfileId}
          setShow={setUserEditPopup}
          currentPage={1}
        />
      ) : null}


      {InActiveCreatePop &&
      state.ClientBranchIDs.userProfileId != "" &&
      state.ClientBranchIDs.userProfileId != undefined ? (
        <ActiveEmployeeCreate
          show={InActiveCreatePop}
          ActiveFor={ActiveFor}
          setShow={setInActiveCreatePoup}
          UserID={state.ClientBranchIDs.userProfileId}
          setTogleActive={setTogleActive}
        />
      ) : null}

      {/* ----Black----list---------------------------------- */}
      {createblack ? (
        <BlackListCeatePoup
          show={createblack}
          setShow={setcreatepoupblack}
          currentPage={newpages}
          EditId={""}
          selectVal={""}
          datas={""}
          ActiveFor={ActiveFor}
        />
      ) : null}
    </>
  );
};

export default UserProfile;
